import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import SkeletonForTypography from 'components/SkeletonForTypography/SkeletonForTypography';

const ProspectRegistrationDrawerFormLoading = () => (
  <Box
    padding="8x"
  >
    <SkeletonForTypography
      $variant="title"
      $lines={4}
      $highlightColor="white"
      marginBottom={{ xs: '3x', lg: '2x' }}
      maxWidth="80%"
    />
  </Box>
);

export default ProspectRegistrationDrawerFormLoading;
